enum LOCALE {
  EN = 'en',
  IT = 'it',
}

export default LOCALE;
